import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SunriseIcon, ClockIcon, BatteryWarningIcon, MoonIcon } from 'lucide-react';
export function AgitationSection() {
  const loops = [{
    label: 'Mañana',
    icon: <SunriseIcon className="w-7 h-7 text-amber" data-id="element-19" data-mp="37abt4xf0k8vi" />,
    text: 'Te despertás y antes de sentir tu propio cuerpo, ya estás en el celular. Ya estás en el mundo de los demás. Ya saliste de vos.'
  }, {
    label: 'Día',
    icon: <ClockIcon className="w-7 h-7 text-amber" data-id="element-20" data-mp="3g9p11lnhope4" />,
    text: 'El día arranca en modo reactivo. Apagás incendios. Respondés. Cumplís. A veces entrenás, a veces no. Comés lo que hay, no lo que necesitás.'
  }, {
    label: 'Tarde',
    icon: <BatteryWarningIcon className="w-7 h-7 text-amber" data-id="element-21" data-mp="3v0z3dpcejal8" />,
    text: 'Llegás a casa y querés estar presente, pero llegás vacío. Le das lo que sobra a los que más querés.'
  }, {
    label: 'Noche',
    icon: <MoonIcon className="w-7 h-7 text-amber" data-id="element-22" data-mp="7wrl72we4gp7" />,
    text: 'En vez de cerrar el día, lo prolongás. Pantalla hasta tarde. Ese momento de "descanso" que en realidad es más estimulación.'
  }];
  return <section id="agitation" className="py-14 md:py-32 bg-charcoal-dark border-y border-charcoal-light" data-id="element-23" data-mp="2pqjcglg7ohd8">
      <div className="max-w-5xl mx-auto px-6" data-id="element-24" data-mp="2kv41c19l8zki">
        <FadeIn data-id="element-25" data-mp="2fuq47e9iza19">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-4 md:mb-6 text-center" data-id="element-26" data-mp="2fv854o74ucfi">
            Así se ve en un día normal.
          </h2>
          <p className="text-center text-offwhite-dim mb-10 md:mb-16 text-lg max-w-2xl mx-auto" data-id="element-27" data-mp="38i2d4lmrjjc3">
            Y así, día tras día, el loop se repite. No porque seas débil.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-10 md:mb-16" data-id="element-28" data-mp="2ytarev8apv9m">
          {loops.map((loop, index) => <FadeIn key={loop.label} delay={index * 0.08} direction="up" className="bg-charcoal p-6 md:p-8 rounded-sm border border-charcoal-light flex flex-col" data-id="element-29" data-mp="3kax0ji6y0e" data-mpi={index}>
              <div className="flex items-center gap-4 mb-4" data-id="element-30" data-mp="1pma5hf5pzlhf">
                <div className="bg-charcoal-dark w-12 h-12 rounded-full flex items-center justify-center border border-charcoal-light shrink-0" data-id="element-31" data-mp="1tk7w8mf52fmx">
                  {loop.icon}
                </div>
                <span className="text-xs font-heading font-bold text-sand uppercase tracking-[0.2em]" data-id="element-32" data-mp="1krwio154imod">
                  {loop.label}
                </span>
              </div>
              <p className="text-offwhite-dim leading-relaxed" data-id="element-33" data-mp="1avjgsfzfd2ij">{loop.text}</p>
            </FadeIn>)}
        </div>

        <div className="max-w-3xl mx-auto text-center space-y-6 md:space-y-8" data-id="element-34" data-mp="wwk0bvm2ftxg">
          <FadeIn delay={0.2} data-id="element-35" data-mp="11tjx1fx0zkbw">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-sand" data-id="element-36" data-mp="11uv8m1wppwdk">
              Porque perdiste coherencia.
            </h3>
            <p className="mt-6 text-lg text-offwhite-dim" data-id="element-37" data-mp="2w82ydf5tzhsc">
              Coherencia no es perfección. No es tenerlo todo bajo control.
            </p>
            <p className="mt-4 text-xl font-medium text-offwhite" data-id="element-38" data-mp="36ct3tv0g141b">
              Coherencia es cuando lo que pensás, lo que sentís y lo que hacés
              van en la misma dirección.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-39" data-mp="3f6ppz9tlyggq">
            <p className="text-lg text-offwhite-dim" data-id="element-40" data-mp="3ae4um3v1zvb3">
              Cuando eso se rompe, el esfuerzo no alcanza. Podés hacer todo
              "bien" y aun así sentirte fuera de lugar. Fuera de vos.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-41" data-mp="3k2wm6aw7cdlh">
            <div className="inline-block p-6 border-l-4 border-sand bg-charcoal text-left" data-id="element-42" data-mp="3k5sijuseiu7t">
              <p className="text-xl font-heading font-bold text-offwhite" data-id="element-43" data-mp="1vz17q9tmznu">
                Y tiene solución.
              </p>
              <p className="mt-2 text-sand font-medium" data-id="element-44" data-mp="23pg30db9t6ao">
                12 semanas para construir desde quien realmente sos.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}